import Navbar from '@src/main/shared/ui/components/navbar/NavBar';
import { FC, PropsWithChildren } from 'react';

const NavbarLayout: FC<PropsWithChildren> = ({ children }) => (
  <div>
    <Navbar />
    <div>{children}</div>
  </div>
);

export default NavbarLayout;
